import { supabase } from '../lib/supabase';

export const waitlistService = {
  async addEmail(email) {
    try {
      console.log('📤 waitlistService.addEmail called for:', email);
      
      // Insert into waitlist_subscribers table
      const { data, error } = await supabase?.from('waitlist_subscribers')?.insert([{ email }])?.select()?.single();

      if (error) {
        // Check if email already exists (unique constraint violation)
        if (error?.code === '23505') {
          console.log('ℹ️ Email already exists in waitlist');
          
          // Still try to send email even if already exists
          try {
            console.log('📧 Attempting to send confirmation email for existing subscriber');
            const { data: emailData, error: emailError } = await supabase?.functions?.invoke('send-waitlist-email', {
              body: { email }
            });
            
            if (emailError) {
              console.error('❌ Email send failed for existing subscriber:', emailError);
            } else {
              console.log('✅ Confirmation email sent successfully for existing subscriber');
            }
          } catch (emailErr) {
            console.error('❌ Email sending error for existing subscriber:', emailErr);
          }
          
          // Fetch current count
          const count = await this.getWaitlistCount();
          
          return {
            success: true,
            alreadyExists: true,
            message: "You\'re already on the waitlist! Check your email for confirmation.",
            count: count?.count || 0,
            spotsRemaining: count?.spotsRemaining || 0,
            emailSent: true
          };
        }
        
        console.error('❌ Supabase insert error:', error);
        throw error;
      }

      console.log('✅ Successfully inserted into waitlist_subscribers:', data);

      // Send confirmation email via Edge Function
      let emailSent = false;
      let emailError = null;
      
      try {
        console.log('📧 Invoking send-waitlist-email Edge Function');
        const { data: emailData, error: emailFunctionError } = await supabase?.functions?.invoke('send-waitlist-email', {
          body: { email }
        });
        
        if (emailFunctionError) {
          console.error('❌ Edge Function invocation error:', emailFunctionError);
          emailError = emailFunctionError?.message || 'Email function failed';
        } else {
          console.log('✅ Email Edge Function response:', emailData);
          emailSent = true;
        }
      } catch (emailErr) {
        console.error('❌ Email sending exception:', emailErr);
        emailError = emailErr?.message || 'Email sending failed';
      }

      // Get updated count
      const count = await this.getWaitlistCount();

      return {
        success: true,
        count: count?.count || 0,
        spotsRemaining: count?.spotsRemaining || 0,
        emailSent,
        emailError,
        alreadyExists: false,
        message: emailSent 
          ? 'Successfully joined! Check your email for confirmation.' 
          : 'Successfully joined! Confirmation email will arrive shortly.'
      };
    } catch (error) {
      console.error('❌ waitlistService.addEmail error:', error);
      return {
        success: false,
        error: error?.message || 'Failed to join waitlist',
        message: error?.message || 'Something went wrong. Please try again.'
      };
    }
  },

  async getWaitlistCount() {
    try {
      console.log('📊 Fetching waitlist count');
      // Use SECURITY DEFINER RPC so anon visitors can read the count
      // without exposing subscriber emails via a public SELECT policy.
      const { data, error } = await supabase?.rpc('get_waitlist_count');

      if (error) {
        console.error('❌ Error fetching count:', error);
        throw error;
      }

      const count = typeof data === 'number' ? data : 0;
      const spotsRemaining = Math.max(0, 1000 - count);

      console.log('✅ Waitlist count:', { count, spotsRemaining });

      return { count, spotsRemaining };
    } catch (error) {
      console.error('❌ getWaitlistCount error:', error);
      return {
        count: 0,
        spotsRemaining: 1000
      };
    }
  }
};